import React from 'react'
import { UserProfileModel } from 'mvppoker-portal-common/api'
import { CgUserAdd } from 'react-icons/cg'
import { Info } from '@mui/icons-material'
import { MVPButton } from '../../../Buttons/MVPButton'
import './FriendsFindListItem.scss'

export interface FriendsFindListItemActions
{
	clickInvite: (userProfile: UserProfileModel) => void
	clickProfile: (userProfile: UserProfileModel) => void
}
export interface FriendsFindListItemProps extends FriendsFindListItemActions
{
	userProfile: UserProfileModel
}

export const FriendsFindListItem: React.FC<FriendsFindListItemProps> = ({ userProfile, clickInvite, clickProfile }) =>
{
    const { avatar, name } = userProfile.info
	return (
		<div className='friends-find-list-item mvp-list-item'>
            <img id='user-avatar' className='avatar' src={avatar} alt='avatar'/>
            <p style={{ width:'60%' }}>{name}</p>
            <div className='row'>
                <MVPButton id='invite-button' className='friends-find-button' onClick={() => clickInvite(userProfile)} >
                    <CgUserAdd />
                    Invite
                </MVPButton>
                <MVPButton className='friends-find-button' onClick={() => clickProfile(userProfile)} >
                    <Info />
                    Info
                </MVPButton>
            </div>
		</div>
	)
}
